import { useState } from 'hooks'
import { cn } from 'utils'
import { Logic } from './logic/logic'
import { Visual } from './visual/visual'
import { getEditorSaveComponents } from './selector'
import { QuestionScroller } from './common/common'

type State = {
	editorSubmitButton?: HTMLElement
	editorErrorDiv?: HTMLDivElement
}

export const Editor = (() => {
	const { state, setState } = useState<State>()

	const initSaveButton = () => {
		const { editorSubmitButton, editorErrorDiv } = state

		if (!editorSubmitButton) {
			return
		}

		if (editorErrorDiv) {
			editorSubmitButton.setAttribute('disabled', 'disabled')
			cn.addClass(editorSubmitButton, 'pointer-events-none')
			cn.addClass(editorSubmitButton, 'bg-gray-500')
			return
		}

		editorSubmitButton.removeAttribute('disabled')
		cn.removeClass(editorSubmitButton, 'pointer-events-none')
		cn.removeClass(editorSubmitButton, 'bg-gray-500')
	}

	const init = (isAjax: boolean) => {
		setState({ ...getEditorSaveComponents() })
		initSaveButton()
		Logic.init()
		Visual.init()
		QuestionScroller.init(isAjax)
	}

	return {
		init,
	}
})()
